import { IDmGioiTinh } from "../../../model/respone/category/IDmGioiTinh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmGioiTinhActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmGioiTinh[],
  LOAD_ERRR: "",
};
export const eDmGioiTinhActionIds = generateActionTypeIds(
  eDmGioiTinhActionsObj,
  "GIOI_TINH"
);
export type IDmGioiTinhActionTypes = IGenericActionType<
  typeof eDmGioiTinhActionsObj,
  "GIOI_TINH"
>;
